import { PaginatedResult } from 'Src/models/pageOpts';
import { coreService } from 'Src/network/AutomatedService';
import { definitions } from 'Src/vendor/posapi/pos';

type DayPart = definitions['types.DayPart'];

type DayPartGetAllResponse = PaginatedResult<DayPart>;

const serviceKey = {
  getAll: 'POS:GET:DayParts',
} as const;

const service = {
  getAll: async () => {
    const response = await coreService[serviceKey.getAll]({});
    return response as unknown as DayPartGetAllResponse;
  },
} as const;

export default service;
export { serviceKey };
export type { DayPart, DayPartGetAllResponse };

